export interface PermissionsType {
  disabled: any[];
  enabled: any[];
}

export interface RoleConfig {
  id: number;
  name: string;
  permissions: Record<string, PermissionsType>;
  generalConfig?: Record<string, string>;
}

export interface RoleForm {
  roleName: string;
  permissions: string[];
  generalConfig?: Record<string, string>;
}

interface Permission {
  [key:string]: boolean;
}

export interface RoleType {
  id: number;
  roleName: string;
  permissions : Record<string, Permission>;
  generalConfig?: Record<string, string>;
}

export interface RoleManagementForm {
  [key: string] : RoleType;
}

export enum Role {
  ADMIN = 'admin',
  SuperAdmin = 'super_admin',
}